import { render, staticRenderFns } from "./FormatoPedidosNew.vue?vue&type=template&id=3dd32f5a&scoped=true"
import script from "./FormatoPedidosNew.vue?vue&type=script&lang=js"
export * from "./FormatoPedidosNew.vue?vue&type=script&lang=js"
import style0 from "./FormatoPedidosNew.vue?vue&type=style&index=0&id=3dd32f5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd32f5a",
  null
  
)

export default component.exports